var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('db-page',{attrs:{"title":"Users"}},[_c('h2',[_vm._v(" All Users ")]),_c('ion-list',_vm._l((_vm.users),function(user){return _c('ion-item',{key:user.id,attrs:{"button":""},on:{"click":function($event){return _vm.onClickUser(user)}}},[_vm._v(" ["+_vm._s(user.id)+"] "+_vm._s(user.tel)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }